<template>
  <div class="bg-white">
    <div class="main-width">
      <div class="my-5">
        <VBreadcrumb :options="[{ label: '首页', to: '/' }, {label: '原创资讯'}]"></VBreadcrumb>
      </div>
      <el-carousel indicator-position="none" height="360px">
        <el-carousel-item class="rounded" v-for="(swiper, index) in adStore.state" :key="index">
          <nuxt-link :tag="swiper.url ? 'a' : 'span'" :to="swiper.url" target="_blank">
            <el-image fit="cover" class="w-full h-full" :src="swiper.path_url" />
          </nuxt-link>
        </el-carousel-item>
      </el-carousel>

      <h2 class="flex pt-5 pb-3">
        <span class="text-dark font-semibold text-2xl my-2">原创资讯</span>
      </h2>

      <el-row type="flex" class="consultations flex-wrap main-width consultation_card" :gutter="12">
        <el-col class="mb-3" v-for="item in consultations" :key="item.no" :span="6">
          <consultation-card :report="item" />
        </el-col>
      </el-row>
      <div class="footer flex justify-center" v-if="pagination.page_index < pagination.total_page">
        <el-button class="load-btn" type="info" @click="onLoadMore" :loading="isLoading">查看更多信息</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, useFetch } from "@nuxtjs/composition-api";
import usePagination from "~/composables/usePagination";
import usePlatformAdvertBanner from '~/composables/usePlatformAdvertBanner'
import { searchCommunity } from "@/services/company";
import ConsultationCard from "@/views/company/ConsultationCard.vue";
import PlatformAdvertStairSwiper from "~/components/product/PlatformAdvertStairSwiper.vue"
import VBreadcrumb from '@/components/VBreadcrumb.vue'

export default {
  name: 'OriginalHome',
  layout: "Main",
  auth: false,
  components: { ConsultationCard,PlatformAdvertStairSwiper,VBreadcrumb },
  head: {
    title: '原创资讯',
  },
  setup() {
    const consultations = ref([]);
    const { execute, pagination, isLoading, enabledLoadMore } = usePagination(
      ({ page_index, page_size }) =>
        searchCommunity({
          cate: 'original',
          page_index,
          page_size,
        }),
      undefined,
      { immediate: false }
    );
    pagination.page_size = 52;
    const { fetch } = useFetch(async () => {
      let data = await execute(0, pagination);
      consultations.value = consultations.value.concat(data.list);
    });

    const adStore = ref(usePlatformAdvertBanner(36));

    async function onLoadMore() {
      pagination.page_index += 1;
      fetch()
    }
    return { consultations, pagination, isLoading, onLoadMore, enabledLoadMore,adStore }
  }
};
</script>

<style lang="scss" scoped>
.consultation_card {
  padding-bottom: 40px;
}
.load-btn {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  --tw-border-opacity: 1;
  border-color: rgba(31, 33, 41, var(--tw-border-opacity));
  border-radius: 0.25rem;
  height: 44px;
  margin-bottom: 35px;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  width: 218px;
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
}
.load-btn:hover, .load-btn:focus {
  --tw-bg-opacity: 1;
  background-color: rgba(230, 232, 242, var(--tw-bg-opacity));
  --tw-border-opacity: 1;
  border-color: rgba(230, 232, 242, var(--tw-border-opacity));
  opacity: 0.8;
}
.load-btn:active {
  opacity: 0.95;
}
</style>